import React from 'react';
import { Snackbar, Slide, Typography, Stack } from '@mui/material';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import { setAlert } from '@store/appStore';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ReportIcon from '@mui/icons-material/Report';

const SlideTransition = (props: any) => {
    return <Slide {...props} direction="down" />;
};

const AlertMessage = () => {
    const { alert } = useSelector((state: RootReducer) => state.app);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(
            setAlert({
                ...alert,
                open: false
            })
        );
    };

    const handleMainTitle = () => {
        if (alert.severity === 'success') {
            return <Typography variant="h6">Operación exitosa</Typography>;
        }
        return <Typography variant="h6">¡Ups! Algo salió mal</Typography>;
    };

    return (
        <Snackbar
            open={alert.open}
            autoHideDuration={5000}
            onClose={handleClose}
            TransitionComponent={SlideTransition}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
        >
            <Alert
                variant="filled"
                onClose={handleClose}
                severity={alert.severity}
                iconMapping={{
                    success: <CheckCircleIcon fontSize="large" />,
                    info: <InfoIcon fontSize="large" />,
                    warning: <WarningIcon fontSize="large" />,
                    error: <ReportIcon fontSize="large" />
                }}
                action={
                    <IconButton onClick={handleClose}>
                        <CloseIcon fontSize="medium" />
                    </IconButton>
                }
            >
                <Stack>
                    {handleMainTitle()}
                    <Typography variant="body1">{alert.message}</Typography>
                </Stack>
            </Alert>
        </Snackbar>
    );
};

export default AlertMessage;
